var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6719 105C85.5247 105 105.672 84.8526 105.672 59.9998C105.672 35.1469 85.5247 14.9998 60.6719 14.9998C35.8191 14.9998 15.6719 35.1469 15.6719 59.9998C15.6719 84.8526 35.8191 105 60.6719 105Z",
    stroke: "#FF8E00",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6726 89.9419C63.7473 89.9419 66.2397 87.4494 66.2397 84.3748C66.2397 81.3001 63.7473 78.8076 60.6726 78.8076C57.598 78.8076 55.1055 81.3001 55.1055 84.3748C55.1055 87.4494 57.598 89.9419 60.6726 89.9419Z",
    fill: "#FF8E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6719 67.4998V63.7498C63.2678 63.7498 65.8053 62.98 67.9637 61.5378C70.1221 60.0956 71.8044 58.0458 72.7978 55.6475C73.7912 53.2492 74.0511 50.6102 73.5447 48.0642C73.0383 45.5182 71.7882 43.1796 69.9527 41.344C68.1171 39.5084 65.7784 38.2584 63.2324 37.752C60.6864 37.2455 58.0474 37.5054 55.6492 38.4988C53.2509 39.4922 51.201 41.1745 49.7588 43.3329C48.3166 45.4913 47.5469 48.0289 47.5469 50.6248",
    stroke: "#FF8E00",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.7cb63abb52cc850f5393087a5d321080.svg";
export { ForwardRef as ReactComponent };